import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class EquipmentSearchService extends ApiService {
    baseUrl = 'apparatus/models-pages';

    getEquipment(title: string = '', page: number = 1) {
        return this.get({
            queryParams: {
                title,
                items_per_page: 7,
                page,
            }
        }).pipe();
    }
}
